import {
  ANALYTICS_ACTION_CLICKED,
  ANALYTICS_SUBJECT_BUTTON,
  UI_EVENT_TYPE,
} from '@atlassian/mpac-analytics';

import bootstrapConfig from '../../../app/bootstrapConfig';

export const EVENT_CONTAINER_APP_HEADER = 'appHeader';
export const EVENT_CONTAINER_NAV_BAR = 'navBar';
export const EVENT_CONTAINER_SITE_SELECTOR = 'siteSelector';
export const EVENT_CONTAINER_APP_LISTING_PRICING_TAB = 'appListingPricingTab';
export const EVENT_CONTAINER_CERTIFICATION_SECTION = 'certificationSection';

const EVENT_CONTAINER_ADDON_DISCOVERY = 'addonDiscovery';

export const trackEvent = ({
  eventContainer,
  eventComponent,
  eventName,
  actionSubjectId,
  event,
  label,
  ...additionalProperties
}) => {
  try {
    window?.ace?.analytics.Tracking.trackEvent(eventName, {
      eventType: UI_EVENT_TYPE,
      eventContainer,
      eventComponent,
      actionSubjectId,
      event,
      label,
      schemaVersion: 1,
      featureFlags: bootstrapConfig.get().featureFlags,
      ...additionalProperties,
    });
  } catch (error) {
    console.error('ace.analytics.Tracking.trackEvent threw an error', error);
  }
};

export const trackPageView = (referrer, name, additionalProperties) => {
  const bootstrap = bootstrapConfig.get();
  if (window.ace && window.ace.analytics && window.ace.mkt) {
    try {
      window?.ace?.analytics.Tracking.pageView(name, name, {
        referrer,
        context_atl_path: window.ace.mkt.Cookie.readCookie('__atl_path') || '',
        utmz: window.ace.mkt.Cookie.readCookie('__utmz') || '',
        ga_clientid: window.ace.mkt.Cookie.readCookie('_ga') || '',
        featureFlags: bootstrap.featureFlags,
        screenNameOverride: name,
        ...additionalProperties,
      });
    } catch (error) {
      console.error('ace.analytics.Tracking.pageView threw an error', error);
    }
  }
};

export const trackAppListing = ({
  eventContainer,
  eventComponent,
  eventName,
  actionSubjectId,
  event,
  label,
  appKey,
  hosting,
  ...additionalProperties
}) =>
  trackEvent({
    eventContainer,
    eventComponent,
    eventName,
    actionSubjectId,
    event,
    label,
    category: 'appListing',
    appKey,
    hosting,
    ...additionalProperties,
  });

export const trackTryModal = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Try-Modal-Trigger',
    actionSubjectId: 'tryModalTrigger',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Try it free',
    appKey,
    source: 'appListingPage',
    hosting,
    paymentModel,
  });

export const trackBuyModal = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Buy-Modal-Trigger',
    actionSubjectId: 'buyModalTrigger',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Buy it now',
    appKey,
    source: 'appListingPage',
    hosting,
    paymentModel,
  });

export const trackTryButton = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Try',
    actionSubjectId: 'installButton',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Start Free Trial',
    appKey,
    source: 'selectHostingModel',
    hosting,
    paymentModel,
  });

export const trackBuyButton = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Buy',
    actionSubjectId: 'installButton',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Subscribe Now',
    appKey,
    source: 'selectHostingModel',
    hosting,
    paymentModel,
  });

export const trackAddonDiscovery = ({
  eventName,
  actionSubject,
  actionSubjectId,
  action,
  label,
  payload,
}) =>
  trackEvent({
    eventContainer: EVENT_CONTAINER_ADDON_DISCOVERY,
    eventComponent: actionSubject,
    eventName,
    actionSubjectId,
    event: action,
    label,
    category: 'addonDiscovery',
    ...payload,
    ...payload.attributes,
  });

// Manage apps track events
export const trackManageApps = ({
  eventContainer,
  actionSubject,
  action,
  actionSubjectId,
  ...additionalProperties
}) =>
  trackEvent({
    eventContainer,
    eventComponent: actionSubject,
    event: action,
    actionSubjectId,
    category: 'manageApps',
    ...additionalProperties,
  });

// Manage partner pages track events
export const trackManagePartnerAccount = ({
  eventContainer,
  actionSubject,
  action,
  actionSubjectId,
  ...additionalProperties
}) => {
  const vendorData = bootstrapConfig.get().vendorData;
  const commonVendorAttributes =
    vendorData?.id && vendorData?.name
      ? {
          partnerId: vendorData.id,
          partnerName: vendorData.name,
        }
      : {};
  trackEvent({
    eventContainer,
    eventComponent: actionSubject,
    event: action,
    actionSubjectId,
    category: 'managePartner',
    ...commonVendorAttributes,
    ...additionalProperties,
  });
};
